import React from "react";

const projectImages = [
  {
    src: "images/PARADISE/1.jpg",
    url: "https://sai-suncity-taloja.navi-mumbai-project.com/",
  },
  {
    src: "images/PARADISE/2.jpg",
    url: "https://sai-world-city-panvel.navi-mumbai-project.com/",
  },
  {
    src: "images/PARADISE/3.jpg",
    url: "https://sai-world-pyramid-nerul.navi-mumbai-project.com/",
  },
  {
    src: "images/PARADISE/4.jpg",
    url: "https://sai-world-empire-kharghar.navi-mumbai-project.com/",
  },
  // {
  //   src: "images/PARADISE/5.jpg",
  //   url: "https://sai-world-retreat-lonavala.navi-mumbai-project.com/",
  // },
  {
    src: "images/PARADISE/SAI PALM VIEW, NERUL.jpg",
    url: "https://sai-palm-view-nerul.navi-mumbai-project.com/",
  },
  {
    src: "images/PARADISE/6.jpg",
    url: "https://sai-prerna-kharghar.navi-mumbai-project.com/",
  },
  // {
  //   src: "images/PARADISE/7.jpg",
  //   url: "https://sai-symphony-kharghar.navi-mumbai-project.com/",
  // },
  {
    src: "images/PARADISE/8.jpg",
    url: "https://sai-platinum-kharghar.navi-mumbai-project.com/",
  },
];

const Paradise = () => {
  return (
    <div className="container mx-auto px-1 sm:px-8" id="gallery">
      <h1 className="text-4xl sm:text-4xl md:text-5xl lg:text-[48px] font-bold text-center my-8 transition-all duration-300">
        PARADISE PROJECTS
      </h1>
      <div className="flex flex-wrap gap-[1vh] p-[1vh] max-w-full mx-auto bg-[#126958] justify-center">
        {projectImages.map((image, index) => (
          <div
            key={index}
            className="w-full sm:w-[calc(50%-1vh)] md:w-[calc(33.333%-1vh)] gallery-item group"
          >
            <a href={image.url} target="_blank" rel="noopener noreferrer">
              <img
                src={image.src}
                alt={`Gallery ${index + 1}`}
                className="w-full h-[300px] object-cover transition-all duration-100 ease-out group-hover:scale-104 group-hover:filter-none"
              />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Paradise;
